import React from "react";
import { motion } from "framer-motion";
import { Mail, PartyPopper, Phone, Instagram } from "lucide-react";
import { CONTACT, EMAIL, PHONES, INSTAGRAM } from "../../data/content";
import RevealSection from "./RevealSection";

export default function Contacte() {
  return (
    <RevealSection id="contacte" className="px-5 py-24">
      <div className="mx-auto max-w-2xl">
        <motion.div
          initial={{ rotate: -1.5 }}
          whileInView={{ rotate: 0 }}
          viewport={{ once: true }}
          transition={{ type: "spring", stiffness: 160, damping: 14 }}
          className="relative collage tone-white p-10 text-center sm:p-14"
        >
          <motion.img
            src="/logo-mini.png"
            alt="Karamiko"
            initial={{ scale: 0, rotate: -30 }}
            whileInView={{ scale: 1, rotate: 0 }}
            viewport={{ once: true }}
            transition={{ type: "spring", stiffness: 200, damping: 12 }}
            className="mx-auto mb-6 h-24 w-24 object-contain drop-shadow"
            data-testid="contact-logo"
          />

          <span className="font-hand text-2xl font-bold text-terracotta">{CONTACT.kicker.toLowerCase()}</span>
          <h2 className="mt-1 font-display text-4xl font-bold text-forest sm:text-5xl">{CONTACT.title}</h2>
          <p className="mx-auto mt-4 max-w-lg font-body leading-relaxed text-forest/80">{CONTACT.text}</p>

          <motion.a
            href={`mailto:${EMAIL}`}
            whileHover={{ scale: 1.04, rotate: -1 }}
            whileTap={{ scale: 0.97 }}
            className="mt-8 inline-flex items-center gap-3 rounded-full bg-forest px-8 py-4 font-display text-lg font-semibold text-paper paper-shadow transition-colors hover:bg-terracotta"
            data-testid="contact-email-link"
          >
            <Mail className="h-5 w-5" />
            {EMAIL}
          </motion.a>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
            {PHONES.map((p) => (
              <a
                key={p.number}
                href={`tel:+34${p.number.replace(/\s/g, "")}`}
                className="inline-flex items-center gap-2 font-body font-semibold text-forest link-draw"
                data-testid={`contact-phone-${p.name.toLowerCase()}`}
              >
                <Phone className="h-4 w-4 text-sage" />
                {p.name} · {p.number}
              </a>
            ))}
            <a
              href={INSTAGRAM.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 font-body font-semibold text-forest link-draw"
              data-testid="contact-instagram"
            >
              <Instagram className="h-4 w-4 text-sage" />
              {INSTAGRAM.handle}
            </a>
          </div>

          <p className="mt-7 inline-flex items-center gap-2 font-hand text-xl font-bold text-forest/60" data-testid="contact-reward-msg">
            <PartyPopper className="h-5 w-5 text-terracotta" />
            Has arribat al final del camí. Gràcies per acompanyar-nos!
          </p>
        </motion.div>
      </div>
    </RevealSection>
  );
}
